// extracted by mini-css-extract-plugin
export default {"translationsAddMonitoringTypesDrawer__footer":"styles_translations-add-monitoring-types-drawer__footer__Hy7vs"};